import { createHelpers } from 'vuex-map-fields';

const { getUproxCountField, updateUproxCountField } = createHelpers({
    getterType: `getUproxCountField`,
    mutationType: `updateUproxCountField`,
});

const state = {
    uprox_card_status : [],
}

// actions
const actions = {
    LOAD_MENU_COUNTS ({commit}) {
        let checkboxes = document.querySelectorAll('input[name="cid[]"]');
        let ids = Array.from(checkboxes).map(cb => cb.value);

        api.post('/uprox/users',{
            'os_ids' : ids,
        }).then(({data}) => {
            if(data.status === 'operation_success') {
                commit('uprox_counts', data.data);
            }
        }).catch(err => {
            commit('uprox_counts', []);
        });
    },
}

const getters = {
    getUproxCountField,


    items() {
        return state.uprox_card_status;
    },
}

// mutations
const mutations = {
    updateUproxCountField,

    uprox_counts (state, data) {
        state.uprox_card_status = [];
        if(data.length > 0) {
            data.map(item => {
                item.os_id = 0;
                if(item.hasOwnProperty("adv_fields")) {
                    let adv_fields = item.adv_fields;
                    if(adv_fields.hasOwnProperty('os_id')) {
                        item.os_id = parseInt(adv_fields.os_id);
                    }
                }
                state.uprox_card_status.push(item);
            })
            EventBus.$emit('uprx_count_ready',data);
        }
    },
}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}
